export const createValueDefinitionKey = (
  value: string,
) => (value ? `VALUEDEFINITION_${value.toLocaleUpperCase()}` : value);

export const createCountryKey = (
  value: string,
) => (value ? `COUNTRY_NAME_${value.toLocaleUpperCase()}` : value);
